import * as stylex from "@stylexjs/stylex";
import { replayStyles as styles } from "../viewer/replay.styles";
import type {
  CoworldReplayFrameProps,
  ReplaySession,
  Playback,
} from "./replay-frame.types";

function replayViewerUrl({
  session,
  viewerClient,
  chrome,
  achievement,
  letterboxBg,
}: Pick<CoworldReplayFrameProps, "viewerClient" | "chrome" | "achievement"> & {
  session: ReplaySession;
  letterboxBg: string | null;
}): string {
  const url = new URL(session.viewer_url);

  if (viewerClient === "league") {
    url.pathname = url.pathname
      .replace(/\/client\/replay$/, "/client/league")
      .replace(/\/index\.html$/, "/league.html");
  }

  if (chrome === "off" || chrome === "controls")
    url.searchParams.set("chrome", chrome);

  if (achievement) url.searchParams.set("achievement", achievement);

  if (letterboxBg) url.searchParams.set("bg", letterboxBg);

  return url.toString();
}

export function ReplayIframe({
  session,
  viewerClient,
  chrome,
  achievement,
  letterboxBg,
  title,
  viewerSize,
  playback,
}: Pick<
  CoworldReplayFrameProps,
  "title" | "viewerSize" | "viewerClient" | "chrome" | "achievement"
> &
  Readonly<{
    session: ReplaySession;
    letterboxBg: string | null;
    playback: Playback;
  }>) {
  const { setIframeNode, onLoad, onError } = playback;
  return (
    <iframe
      ref={setIframeNode}
      src={replayViewerUrl({
        session,
        viewerClient,
        chrome,
        achievement,
        letterboxBg,
      })}
      title={title ?? "Coworld replay"}
      loading="lazy"
      {...stylex.props(styles.iframeElement, !viewerSize && styles.iframe)}
      style={
        viewerSize
          ? {
              width: viewerSize.width,
              height: viewerSize.height,
              display: "block",
            }
          : { overflow: "hidden" }
      }
      // The backend serves viewer documents on an isolated content origin and rejects app-origin copies.
      // oxlint-disable-next-line react/iframe-missing-sandbox -- The isolated content origin requires scripts and its own origin for viewer assets.
      sandbox="allow-scripts allow-same-origin allow-downloads"
      allowFullScreen
      referrerPolicy="no-referrer"
      scrolling="no"
      onLoad={onLoad}
      onError={onError}
    />
  );
}
